import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import SecurityDashboard from '../components/SecurityDashboard';

const AdminSecurity = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-900">
      <Header />
      <div className="p-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center space-x-4 mb-4">
            <button
              onClick={() => navigate('/admin')}
              className="flex items-center gap-2 text-green-300 hover:text-green-400"
            >
              ← Back to Admin Dashboard
            </button>
            <div className="flex space-x-2">
              <button
                onClick={() => navigate('/admin/moderation')}
                className="bg-gray-700 hover:bg-gray-600 text-white px-3 py-1 rounded text-sm"
              >
                Moderation
              </button>
              <button
                onClick={() => navigate('/admin/marketplace')}
                className="bg-gray-700 hover:bg-gray-600 text-white px-3 py-1 rounded text-sm"
              >
                Marketplace
              </button>
              <button
                onClick={() => navigate('/admin/ads')}
                className="bg-gray-700 hover:bg-gray-600 text-white px-3 py-1 rounded text-sm"
              >
                Ads & Slides
              </button>
              <button
                onClick={() => navigate('/admin/analytics')}
                className="bg-gray-700 hover:bg-gray-600 text-white px-3 py-1 rounded text-sm"
              >
                Analytics
              </button>
            </div>
          </div>
          <div>
            <h1 className="text-3xl font-bold text-white mb-2">Security Dashboard</h1>
            <p className="text-gray-300">Monitor security events and system protection</p>
          </div>
        </div>

        {/* Security Dashboard Content */}
        <SecurityDashboard />
      </div>
    </div>
  );
};

export default AdminSecurity;
